
import * as THREE from 'three'
import * as BAS from 'three-bas'

const Animation = (params)=> {


  console.log('Animation');

  const config = {
    hairLength: 10.2,
    hairBase: 0.1,
    maxDelay: 0.5,
    maxDuration: 1.0,
    minBounceAmp: 1.0,
    maxBounceAmp: 2.0,
    minBouncePer: 0.2,
    maxBouncePer: 0.4,
    fuzz: 1.5,
    minHairDrop: 2.0,
    maxHairDrop: 4.0
  };


 

  const plusPositions = params.positions;
   // const prefab = new THREE.CylinderGeometry(0.0, config.hairBase, config.hairLength, 4, 16, false);
  const prefab = new THREE.ConeGeometry(
    config.hairBase,
    config.hairLength,
    4,
    16,
    true
  );

  prefab.translate(0, config.hairLength * 0.5, 0);

  const geometry = new BAS.PrefabBufferGeometry(prefab, plusPositions.length);



   // const max = new THREE.Vector3().setScalar(4).length();
  this.totalDuration = config.maxDuration + config.maxDelay;
  geometry.createAttribute("anim", 0.3, (data, i, count) => {
  const position = plusPositions[i];
  data[0] =
    THREE.Math.mapLinear(position.y, 4, -4, 0, config.maxDelay) *
    THREE.Math.randFloat(0.9, 1.0);
    // data[0] = THREE.Math.mapLinear(position.length(), 0, max, 0, maxDelay);
    data[1] = config.maxDuration;
  });

  // default easeBounceOut factor == 1.70158
  // default easeElasticOut == 1.0, 0.3
  geometry.createAttribute("bounce", 2, (data) => {
    // data[0] = THREE.Math.randFloat(1.7, 8.0);
    data[0] = THREE.Math.randFloat(config.minBounceAmp, config.maxBounceAmp);
    data[1] = THREE.Math.randFloat(config.minBouncePer, config.minBouncePer);
  });

  geometry.createAttribute("startPosition", 3, (data, i) => {
    plusPositions[i].toArray(data);
   });

  const up = new THREE.Vector3(0, 1, 0);
  const normal = new THREE.Vector3(); // not actually the normal, but based on position
  const quat = new THREE.Quaternion();
  geometry.createAttribute("rMin", 4, (data, i) => {
    normal.copy(plusPositions[i]);
    normal.x += THREE.Math.randFloatSpread(config.fuzz);
    normal.y += THREE.Math.randFloatSpread(config.fuzz);
    normal.z += THREE.Math.randFloatSpread(config.fuzz);
    // normal.x *= THREE.Math.randFloat(1.0, fuzz);
    // normal.z *= THREE.Math.randFloat(1.0, fuzz);

    normal.normalize();

    quat.setFromUnitVectors(up, normal);
    quat.toArray(data);
  });
  geometry.createAttribute("rMax", 4, (data, i) => {
    normal.copy(plusPositions[i]);
    normal.x += THREE.Math.randFloatSpread(config.fuzz);
    normal.y -= THREE.Math.randFloat(config.minHairDrop, config.maxHairDrop);
    normal.z += THREE.Math.randFloatSpread(config.fuzz);
    normal.normalize();

    quat.setFromUnitVectors(up, normal);
    quat.toArray(data);
  });

  const material = new BAS.StandardAnimationMaterial({
    flatShading: true,
    uniformValues: {
     metalness: 0.5,
     roughness: 1.0
    },
    uniforms: {
     time: { value: 0 },
     hairLength: { value: config.hairLength }
    },
    vertexParameters: `
        uniform float time;
        uniform float hairLength;
        
        attribute vec2 anim;
        attribute vec2 bounce;

        attribute vec3 startPosition;
        
        attribute vec4 rMin;
        attribute vec4 rMax;
      `,
    varyingParameters: `
        varying float vProgress;
        varying float vY;
      `,
    vertexFunctions: [
     BAS.ShaderChunk.ease_back_out,
     BAS.ShaderChunk.ease_elastic_out,
     BAS.ShaderChunk.ease_expo_out,
     BAS.ShaderChunk.quaternion_rotation
    ],
    vertexPosition: `
        float progress = clamp(time - anim.x, 0.0, anim.y) / anim.y;
        
        float bounceProgress = easeElasticOut(progress, bounce.x, bounce.y);
        // float bounceProgress = easeBackOut(progress, bounce.x * 2.0);
        float growProgress = easeExpoOut(progress);
        float frc = position.y / hairLength;
        
        vY = frc;
        vProgress = growProgress;
        
        transformed.xz *= growProgress;
        
        // doesn't work with fuzz + overshoot ease, but mey give better results
        // vec4 r = mix(rMin, rMax, frc * bounceProgress);
        // transformed = rotateVector(r, transformed);

        // other method
        vec3 pMin = rotateVector(rMin, transformed);
        vec3 pMax = rotateVector(rMax, transformed);
        transformed = mix(pMin, pMax, frc * bounceProgress);

        transformed += startPosition;
      `,
    fragmentInit: `
        if (vProgress == 0.0 || vY > vProgress) discard;
      `
   });



  THREE.Mesh.call(this, geometry, material);
   // this.customDepthMaterial = BAS.Utils.createDepthAnimationMaterial(material);
}

Animation.prototype = Object.create(THREE.Mesh.prototype);
Animation.prototype.constructor = Animation;
Animation.prototype.animate = function () {
  return TweenMax.to(this, 2.0, {
    time: this.totalDuration,
    ease: Power0.easeOut,
    repeat: -1,
    repeatDelay: 1.0
  });
};
Object.defineProperty(Animation.prototype, "time", {
  get() {
    return this.material.uniforms.time.value;
  },
  set(v) {
    this.material.uniforms.time.value = v;
      // this.customDepthMaterial.uniforms.time.value = v;
  }
});
Animation.prototype.setColor = function (v) {
  this.material.uniforms.diffuse.value.set(v);
};


export default Animation


